(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-single-blogs-page-section"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function () {
    let currentUrl = window.location.href; // Get the current URL
    let urlParts = currentUrl.split('/'); // Split the URL by '/'
    let handle = urlParts[urlParts.length - 2].replaceAll('-', ' ');
    document.querySelector('.shopify-section .category-name').innerHTML = handle;
  });


  } catch(e) { console.error(e); }
})();
})();
